var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTop3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_581_492)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0349 19.3352C33.6947 19.224 30.3201 20.1353 27.4067 22.08C24.1344 24.2666 21.8476 27.4955 20.7943 31.1051C20.5034 31.0696 20.1551 31.0852 19.7415 31.2022C18.1973 31.6404 17.0358 32.9057 16.5136 34.0201C15.8363 35.4724 15.5506 37.3932 15.852 39.376C16.1512 41.3527 16.9862 42.982 18.0307 43.9935C19.0783 45.0056 20.2611 45.3346 21.4361 45.0876C23.1855 44.7142 24.0529 44.4348 23.808 42.805L22.6221 34.9043C22.8612 30.6283 25.0749 26.603 28.7775 24.1277C33.7334 20.8173 40.2309 21.0293 44.958 24.6583C48.2465 27.1795 50.1557 30.9573 50.3761 34.9231L49.5468 40.4497C47.6971 45.5116 43.1114 49.0178 37.8051 49.5155H34.2718C33.36 49.5155 32.6257 50.2498 32.6257 51.1605V52.0284C32.6257 52.9397 33.36 53.674 34.2718 53.674H38.7269C39.6381 53.674 40.3693 52.9397 40.3693 52.0284V51.5746C44.3705 50.5981 47.8631 48.1389 50.1374 44.7095L51.5647 45.0881C52.7261 45.3894 53.923 45.0056 54.9701 43.9941C56.0145 42.982 56.849 41.3532 57.1488 39.3766C57.4511 37.3937 57.1571 35.4761 56.4876 34.0207C55.8155 32.5652 54.8144 31.6409 53.6588 31.3093C53.1747 31.1698 52.6493 31.1187 52.1986 31.1051C51.2461 27.8412 49.2852 24.8729 46.4589 22.7057C43.6801 20.5734 40.375 19.4449 37.0349 19.3352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2492 33.5492C43.4268 33.5492 44.3814 34.5038 44.3841 35.6846C44.3814 36.8622 43.4268 37.8194 42.2492 37.8194C41.0685 37.8194 40.1112 36.8622 40.1112 35.6846C40.1112 34.5043 41.069 33.5492 42.2492 33.5492ZM36.4995 33.5492C37.6798 33.5492 38.6344 34.5038 38.6344 35.6846C38.6344 36.8622 37.6798 37.8194 36.4995 37.8194C35.3183 37.8194 34.3636 36.8622 34.3636 35.6846C34.3636 34.5043 35.3183 33.5492 36.4995 33.5492ZM30.752 33.5492C31.9296 33.5492 32.8868 34.5038 32.8868 35.6846C32.8868 36.8622 31.9296 37.8194 30.752 37.8194C29.5717 37.8194 28.6166 36.8622 28.6166 35.6846C28.6166 34.5043 29.5717 33.5492 30.752 33.5492ZM36.4995 24.3779C30.2381 24.3779 25.1924 29.2576 25.1924 35.6846C25.1924 38.7714 26.3595 41.4995 28.261 43.5012L27.5862 46.5259C27.3638 47.5213 28.0542 48.1907 28.9487 47.6925L31.9024 46.0449C33.3061 46.6544 34.8587 46.9912 36.4995 46.9912C42.7631 46.9912 47.8057 42.1147 47.8057 35.6846C47.8057 29.2576 42.7631 24.3779 36.4995 24.3779Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_581_492",
    x1: 4.5,
    y1: 4,
    x2: 70,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop3);
export default __webpack_public_path__ + "static/media/icon_top3.8f76a4d45da873a36509dc4e60720588.svg";
export { ForwardRef as ReactComponent };